$(document).ready(function(){
	if ($('.announcement-bar').length){
		var announcement_bar = Cookies.get('announcement_bar');
		if (announcement_bar != 'dismiss') {
			$('.announcement-bar').show();
			$('.announcement-bar').on('click', '.close_announcement', function(){
				$('.announcement-bar').hide();
				Cookies.set('announcement_bar', 'dismiss', { expires: 30 });
			});
		}
	}
	var $headerGroup = $('#header-group').children();
	var $headerGroupHeight = 0;
	$headerGroup.each(function(){
		$headerGroupHeight += parseInt($(this).outerHeight());
	});
	$('body').css('--header-group-correction', $headerGroupHeight + 'px');
});

$(document).on('click', '.search-modal__button', function(){
	var $headerGroup = $('#header-group').children();
	var $headerGroupHeight = 0;
	$headerGroup.each(function(){
		$headerGroupHeight += parseInt($(this).outerHeight());
	});
	var $windowScroll = $(window).scrollTop();
	$headerGroupHeight = $headerGroupHeight - $windowScroll;
	$('body').css('--header-group-correction', $headerGroupHeight + 'px');
});

// let dropdownHideTimer = null;
// const HIDE_DELAY = 80;

// function showDropdown(label) {
// 	clearTimeout(dropdownHideTimer);
// 	$('.dropdown_container').hide();
// 	$(`.dropdown_container[data-dropdown="${label}"]`).show();
// 	if($('.header__row--bottom').hasClass('sticky-nav__stick')) {
// 		var $top = $('.sticky-nav__stick').outerHeight();
// 		$('body').css('--header-group-correction', $top + 'px');
// 	} else {
// 		var $headerGroup = $('#header-group').children();
// 		var $headerGroupHeight = 0;
// 		$headerGroup.each(function(){
// 			$headerGroupHeight += parseInt($(this).outerHeight());
// 		});
// 		var $windowScroll = $(window).scrollTop();
// 		$headerGroupHeight = $headerGroupHeight - $windowScroll;
// 		$('body').css('--header-group-correction', $headerGroupHeight + 'px');
// 	}
// }

// function scheduleHideDropdown(label) {
// 	clearTimeout(dropdownHideTimer);
// 	dropdownHideTimer = setTimeout(() => {
// 		$(`.dropdown_container[data-dropdown="${label}"]`).hide();
// 	}, HIDE_DELAY);
// }

// $(document).on('mouseenter', '.menu-list__list-item > a', function () {
// 	const label = $(this).data('label');
// 	showDropdown(label);
// });

// $(document).on('mouseleave', '.menu-list__list-item > a', function () {
// 	const label = $(this).data('label');
// 	scheduleHideDropdown(label);
// });

// $(document).on('mouseenter', '.dropdown_container', function () {
// 	clearTimeout(dropdownHideTimer);
// });

// $(document).on('mouseleave', '.dropdown_container', function () {
// 	const label = $(this).data('dropdown');
// 	scheduleHideDropdown(label);
// });

if (window.Shopify && Shopify.designMode) {
	const hideAll = () => {
		document
			.querySelectorAll('.dropdown_container.is-editor-active')
			.forEach(el => el.classList.remove('is-editor-active'));
	};
	document.addEventListener('shopify:section:select', (e) => {
		const sectionId = e.detail.sectionId;
		hideAll();
		const dropdown = document.querySelector(
			`.dropdown_container[data-section-id="${sectionId}"]`
		);
		if (dropdown) {
			dropdown.classList.add('is-editor-active');
		}
	});
	document.addEventListener('shopify:section:deselect', hideAll);
}

$(window).on('scroll resize', function () {
	const $headerMobile = $('.header__drawer');
	const $header = $('#header-component');
	const $stickyNav = $('.header__row--bottom');
	if ($headerMobile.is(':visible')) return;
	const threshold = 700;
	const navHeight = $stickyNav.outerHeight() || 0;
	const scrollAmount = $(window).scrollTop();
	if (scrollAmount >= threshold) {
		if (!$stickyNav.hasClass('sticky-nav__stick')) {
			$stickyNav.addClass('sticky-nav__stick');
			$header.css('margin-bottom', navHeight + 'px');
			$('body').css('--header-group-correction', navHeight + 'px');
		}
	} else {
		if ($stickyNav.hasClass('sticky-nav__stick')) {
			$stickyNav.addClass('sticky-nav__unstick').removeClass('sticky-nav__stick');
			setTimeout(() => {
				$stickyNav.removeClass('sticky-nav__unstick');
				$header.css('margin-bottom', '0px');
			}, 250);
		}
	}
});
/* --- LEGACY COLOR OPTION CODE ---
$(document).on('click', '.swatch-image-trigger', function(){
	var $this = $(this),
	$image = $this.data('image'),
	$activeItem = $this.closest('div').find('.active');
	if($activeItem.length) {
		$activeItem.removeClass('active');
	}
	$this.addClass('active');
	$this.closest('li').find('.product-media-container:visible[aria-hidden="true"] img').attr('src', $image).removeAttr('srcset');
	console.log($this.closest('li').find('.product-media-container:visible[aria-hidden="true"] img'));
}); 
*/
(function () {
	function fixYotpoTooltip(root = document) {
		const tooltip = root.querySelector('#read-more-tooltip[role="tooltip"]');
		if (!tooltip) return;
		if (tooltip.hasAttribute('aria-label') || tooltip.hasAttribute('aria-labelledby')) {
			return;
		}
		const text = tooltip.textContent.trim();
		if (text) {
			tooltip.setAttribute('aria-label', text);
		}
	}
	fixYotpoTooltip();
	const observer = new MutationObserver((mutations) => {
		for (const mutation of mutations) {
			for (const node of mutation.addedNodes) {
				if (!(node instanceof HTMLElement)) continue;
				if (node.id === 'read-more-tooltip') {
					fixYotpoTooltip(node.parentNode);
					return;
				}
				if (node.querySelector?.('#read-more-tooltip')) {
					fixYotpoTooltip(node);
					return;
				}
			}
		}
	});
	observer.observe(document.body, {
		childList: true,
		subtree: true,
	});
})();

(function () {
	function updateFocusableState(root = document) {
		const hiddenSlides = root.querySelectorAll(
			'slideshow-slide[aria-hidden="true"]'
		);
		hiddenSlides.forEach((slide) => {
			const focusables = slide.querySelectorAll(
				'a, button, input, select, textarea, [tabindex]'
			);
			focusables.forEach((el) => {
				if (!el.hasAttribute('data-orig-tabindex')) {
					el.setAttribute(
						'data-orig-tabindex',
						el.getAttribute('tabindex') ?? ''
					);
				}
				el.setAttribute('tabindex', '-1');
			});
		});
		const visibleSlides = root.querySelectorAll(
			'slideshow-slide[aria-hidden="false"]'
		);
		visibleSlides.forEach((slide) => {
			slide.querySelectorAll('[data-orig-tabindex]').forEach((el) => {
				const original = el.getAttribute('data-orig-tabindex');
				if (original === '') el.removeAttribute('tabindex');
				else el.setAttribute('tabindex', original);
				el.removeAttribute('data-orig-tabindex');
			});
		});
	}
	updateFocusableState();
	const observer = new MutationObserver((mutations) => {
		for (const mutation of mutations) {
			for (const node of mutation.addedNodes) {
				if (!(node instanceof HTMLElement)) continue;
				if (node.classList?.contains('yotpo')) {
					updateFocusableState(node);
					return;
				}
				if (node.matches?.('slideshow-slide') || node.closest?.('slideshow-slide')) {
					updateFocusableState(document);
					return;
				}
			}
		}
	});
	observer.observe(document.body, {
		childList: true,
		subtree: true,
	});
})();

(function ($) {
	if (typeof $ === 'undefined') return;
	const interval = setInterval(function () {
		const $iframe = $('#PBarNextFrame');
		if (!$iframe.length) return;
		if (!$iframe.attr('title')) {
			$iframe.attr('title', 'Shopify preview bar');
		}
		clearInterval(interval);
	}, 300);
	setTimeout(function () {
		clearInterval(interval);
	}, 10000);
})(window.jQuery);


$(document).on('click', '.predictive-search__icon', function(){
	$(this).closest('form').submit();
});

$(window).on('load', function() {
	setTimeout(function(){
		var i = 0;
		$('body > .mega-menu-container .mega-menu-section').each(function() {
			var $this = $(this),
				$dropdown = $this.find('.dropdown_container').data('dropdown'),
				$html = $this.html();
			if($html.trim() !== "") {
				$('.header-menu__inner li[data-dropdown="' + $dropdown + '"]').append('<div class="mega-menu-container" id="mega-menu-' + i + '"><div class="mega-menu-section shopify-section">' + $html + '</div></div>');
				i++;
			}
			$this.remove();
		});
	}, 500)
});

$(document).on('click', '.open-mega-menu', function(){
	$(this).next('.mega-menu-container').toggle();
});

$(document).on('focusout', '.mega-menu-container', function (e) {
	if (this.contains(e.relatedTarget)) return;
	$(this).removeAttr('style');
});
